import React from 'react'
import { Switch, Route, Redirect, useRouteMatch } from 'react-router-dom'

import Home from './home'
import Page404 from '../404'

const Router = () => {
  const { path } = useRouteMatch()

  return (
    <>
      <Switch>
        <Route
          path={`${path}`}
          exact
          render={() => <Redirect to={`${path}/home`}></Redirect>}
        ></Route>
        <Route exact path={`${path}/home`}>
          <Home></Home>
        </Route>
        <Route>
          <Page404 />
        </Route>
      </Switch>
    </>
  )
}

export default Router
